// src/components/ScrollReveal.js
// Wraps children in a Framer Motion whileInView reveal.
// variant="fade"   — simple opacity fade (default)
// variant="up"     — fade + slide up (cards, text blocks)
// variant="left"   — fade + slide from left
// variant="right"  — fade + slide from right
// delay prop       — stagger offset in seconds
import React from 'react';
import { motion } from 'framer-motion';

const variants = {
  fade: {
    hidden: { opacity: 0 },
    visible: { opacity: 1 },
  },
  up: {
    hidden: { opacity: 0, y: 32 },
    visible: { opacity: 1, y: 0 },
  },
  left: {
    hidden: { opacity: 0, x: -32 },
    visible: { opacity: 1, x: 0 },
  },
  right: {
    hidden: { opacity: 0, x: 32 },
    visible: { opacity: 1, x: 0 },
  },
};

const ScrollReveal = ({
  children,
  variant = 'up',
  delay = 0,
  duration = 0.55,
  once = true,
  style,
  className,
}) => (
  <motion.div
    initial="hidden"
    whileInView="visible"
    viewport={{ once, margin: '-60px' }}
    transition={{ duration, delay, ease: [0.22, 1, 0.36, 1] }}
    variants={variants[variant] || variants.up}
    style={style}
    className={className}
  >
    {children}
  </motion.div>
);

// Stagger container — children reveal one by one
export const StaggerContainer = ({ children, stagger = 0.1, style, className }) => (
  <motion.div
    initial="hidden"
    whileInView="visible"
    viewport={{ once: true, margin: '-60px' }}
    variants={{
      hidden: {},
      visible: { transition: { staggerChildren: stagger } },
    }}
    style={style}
    className={className}
  >
    {children}
  </motion.div>
);

// StaggerItem — use inside StaggerContainer
export const StaggerItem = ({ children, variant = 'up', duration = 0.5, style, className }) => (
  <motion.div
    variants={variants[variant] || variants.up}
    transition={{ duration, ease: [0.22, 1, 0.36, 1] }}
    style={style}
    className={className}
  >
    {children}
  </motion.div>
);

export default ScrollReveal;
